export const getSelector = (key: string) => {
  return `[data-tour=${key}]`;
};

export const KEYS = {
  TOGGLE_BUTTON: "toggle-button",
  BACK_BUTTON: "back-button",
  NAVIGATION_BUTTON: "navigation-button",
  ASSESSMENT: {
    CATEGORY_LIST: "category-list",
    ANSWER_BUTTON: "answer-button",
    UPLOAD_BUTTON: "upload-button",
    DOCUMENT_LIST: "document-list",
  },
  CATEGORY: {
    SUB_CATEGORY_LIST: "sub-category-list",
    ANSWER_BUTTON: "category-answer-button",
  },
  SUB_CATEGORY: {
    MULTIPLE_CHOICE: "multiple-choice",
    TEXTAREA: "textarea",
    MARK_AS_COMPLETE_BUTTON: "mark-as-complete-button",
    SAVE_DRAFT_BUTTON: "save-draft-button",
  },
};